import { forwardRef, Ref } from 'react';

import { Close as CloseIcon } from '@mui/icons-material';

import LoaderSpinnerIcon from '../../icons/LoaderIcon';
import { Chip, Props as StylesProps } from './styles';
import useTagVM, { VMProps } from './vm';

export interface Props extends VMProps, StylesProps {}

const Tag = (
  { variant, color = 'default', icon, label, closeIcon, disabled, className, classes, ...props }: Props,
  ref: Ref<HTMLDivElement>
) => {
  const { isLoading, handleClose, onClose } = useTagVM(props);

  return (
    <Chip
      ref={ref}
      label={label}
      variant={variant}
      icon={icon}
      color={color}
      deleteIcon={isLoading ? <LoaderSpinnerIcon /> : closeIcon ? closeIcon : <CloseIcon />}
      onDelete={onClose ? handleClose : undefined}
      disabled={disabled || isLoading}
      className={className}
      classes={classes}
      size="small"
    />
  );
};

export default forwardRef(Tag);
